// S11-9: dashboard footer — version string with SHA/built_at tooltip.
//
// "VISTA <version> · Colorado Communications" replaces the fixed
// "VISTA © 2026 Colorado Communications" per spec. Copyright isn't
// lost — it lives inside the tooltip next to the build metadata so
// there's still a single home for attribution text.
//
// While the version query is pending, the footer shows "VISTA" only —
// better than a blank "loading…" flash, and avoids laying out text
// that immediately shifts when the fetch resolves.

import { useVersionInfo } from '../../hooks/useVersionInfo.js';

function buildTooltip({ commit, builtAt }) {
  const parts = [];
  if (commit && commit !== 'dev') parts.push(`Commit: ${commit}`);
  if (builtAt) parts.push(`Built: ${builtAt}`);
  parts.push('© 2026 Colorado Communications');
  return parts.join('\n');
}

export default function Footer() {
  const { data } = useVersionInfo();
  const version = data?.version || 'dev';
  const tooltip = buildTooltip(data || {});

  return (
    <footer className="border-t border-gray-200 bg-white px-6 py-2 text-center text-xs text-gray-400">
      <span title={tooltip} className="cursor-default">
        VISTA {version} · Colorado Communications
      </span>
    </footer>
  );
}
